const createUrl = (urlPattern) => {
  if (!urlPattern) return false
  const url = urlPattern.replace('[ressourcePath]', process.env.RAZZLE_RESSOURCE_PATH)
  return url
}

export default createUrl
